(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("multiple-wmts-layers", [], factory);
	else if(typeof exports === 'object')
		exports["multiple-wmts-layers"] = factory();
	else
		root["multiple-wmts-layers"] = factory();
})(self, function() {
return 